import { Badge } from "react-bootstrap";

export const verificaSeAtivoERetornaBadge = (
  ativo: string | boolean
): JSX.Element => {
  return ativo === "1" ? (
    <Badge bg="success">Ativo</Badge>
  ) : (
    <Badge bg="danger">Inativo</Badge>
  );
};
